"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenPayloadSchema = exports.AuthResponseSchema = exports.GoogleSignInSchema = exports.MagicLinkVerifySchema = exports.MagicLinkRequestSchema = exports.RegisterRequestSchema = exports.LoginRequestSchema = exports.AuthUserSchema = exports.UserTier = exports.UserRole = void 0;
const zod_1 = require("zod");
exports.UserRole = zod_1.z.enum(['user', 'admin']);
exports.UserTier = zod_1.z.enum(['free', 'starter', 'growth', 'pro', 'scale']);
exports.AuthUserSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    email: zod_1.z.email(),
    displayName: zod_1.z.string().nullable(),
    avatarUrl: zod_1.z.url().nullable(),
    role: exports.UserRole,
    tier: exports.UserTier,
    /**
     * True when the account is on a paid plan in ANY product (a website plan, or
     * Plus/Pro bought on the website, Dunea Desktop or Dunea Work). One balance,
     * one plan per account: a Plus plan unlocks the website's paid features just
     * as a website plan does. Set from the DB on every authenticated request;
     * absent on objects built elsewhere, where `tier` alone decides.
     */
    paidPlan: zod_1.z.boolean().optional(),
    emailVerified: zod_1.z.boolean(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.LoginRequestSchema = zod_1.z.object({
    email: zod_1.z.email(),
    password: zod_1.z.string().min(8),
});
exports.RegisterRequestSchema = zod_1.z.object({
    email: zod_1.z.email(),
    password: zod_1.z.string().min(8),
    displayName: zod_1.z.string().min(1).optional(),
    /** Affiliate referral code the user arrived with (first-touch attribution). */
    ref: zod_1.z.string().min(1).max(120).optional(),
});
exports.MagicLinkRequestSchema = zod_1.z.object({
    email: zod_1.z.email(),
});
exports.MagicLinkVerifySchema = zod_1.z.object({
    email: zod_1.z.email(),
    code: zod_1.z.string().length(6).regex(/^\d{6}$/),
    /** Affiliate referral code the user arrived with (first-touch attribution). */
    ref: zod_1.z.string().min(1).max(120).optional(),
});
exports.GoogleSignInSchema = zod_1.z.object({
    idToken: zod_1.z.string().min(1),
    /** Affiliate referral code the user arrived with (first-touch attribution). */
    ref: zod_1.z.string().min(1).max(120).optional(),
});
exports.AuthResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    user: exports.AuthUserSchema,
    /**
     * True only on the request that created the account. Auth is a single modal
     * (magic link or Google) with no separate signup route, so the client cannot
     * otherwise tell a first sign-in from a returning one — and ad conversions
     * must fire exactly once, in the browser. Optional so older clients and the
     * password login/register paths stay valid.
     */
    isNewUser: zod_1.z.boolean().optional(),
});
exports.TokenPayloadSchema = zod_1.z.object({
    sub: zod_1.z.uuid(),
    email: zod_1.z.email(),
    role: exports.UserRole,
    iat: zod_1.z.number().optional(),
    exp: zod_1.z.number().optional(),
});
